import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { homeRouteFor } from './auth.guard';

/**
 * Restricts a route to the roles listed in its `data: { roles: [...] }`. Unauthenticated users go to /login, exactly as
 * authGuard does; an authenticated user holding none of the roles is sent to their home route. A route with no `roles`
 * is not restricted. SuperAdmin holds no operational role, so it is let in only where `roles` names it.
 */
export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  const roles = route.data?.['roles'] as readonly string[] | undefined;
  if (!roles?.length || roles.some((role) => auth.hasRole(role))) return true;
  return router.createUrlTree([homeRouteFor(auth)]);
};
